import { MobileSettingsKeys, SettingsKeys } from './appSettingsKeys';
import { cleanNulls } from './utils';
const stylesParamColorKeyToAppSettingsMapper = {
  bookButtonBackgroundColor: SettingsKeys.BUTTON_BACKGROUND_COLOR,
  bookButtonBorderColor: SettingsKeys.BUTTON_BORDER_COLOR,
  fillBookButtonTextColor: SettingsKeys.BUTTON_TEXT_COLOR_FILL,
  holeBookButtonTextColor: SettingsKeys.BUTTON_TEXT_COLOR_HOLE,
  explorePlansTextColor: SettingsKeys.EXPLORE_PLANS_TEXT_COLOR,
  borderColor: SettingsKeys.BORDER_COLOR,
  dropdownBackgroundColor: MobileSettingsKeys.MOBILE_CATEGORY_BACKGROUND_COLOR,
  dropdownBorderColor: MobileSettingsKeys.MOBILE_CATEGORY_BORDER_COLOR,
  dropdownTextColor: MobileSettingsKeys.MOBILE_CATEGORY_NAME_COLOR,
  filterBorderColor: SettingsKeys.CATEGORY_DIVIDER_COLOR,
  filterHoverBorderColor: SettingsKeys.CATEGORY_HOVER_BORDER_COLOR,
  filterHoverIndicationColor: SettingsKeys.CATEGORY_HOVER_BACKGROUND_COLOR,
  filterHoverTextColor: SettingsKeys.CATEGORY_HOVER_TEXT_COLOR,
  filterSelectedBorderColor: SettingsKeys.CATEGORY_SELECTED_BORDER_COLOR,
  filterSelectedIndicationColor: SettingsKeys.CATEGORY_SELECTED_UNDERLINE_COLOR,
  filterSelectedTextColor: SettingsKeys.CATEGORY_SELECTED_TEXT_COLOR,
  filterTitleColor: SettingsKeys.CATEGORY_NAME_COLOR,
  infoBackgroundColor: SettingsKeys.BACKGROUND_COLOR,
  moreInfoButtonColor: SettingsKeys.OFFERING_MORE_INFO_LABEL_COLOR,
  serviceDetailsColor: SettingsKeys.OFFERING_DETAILS_COLOR,
  courseAvailabilityColor: SettingsKeys.COURSE_AVAILABILITY_COLOR,
  serviceDividerColor: SettingsKeys.DIVIDER_COLOR,
  serviceImageBackgroundColor: SettingsKeys.IMAGE_BACKGROUND_COLOR,
  serviceNameColor: SettingsKeys.OFFERING_NAME_COLOR,
  serviceTaglineColor: SettingsKeys.OFFERING_TAGLINE_COLOR,
  servicesDividerColor: SettingsKeys.SERVICE_DIVIDER_COLOR,
  widgetBackgroundColor: SettingsKeys.MULTI_OFFERINGS_BACKGROUND_COLOR,
  widgetTitleColor: SettingsKeys.MULTI_OFFERINGS_TITLE_COLOR,
  filterBackgroundColor: SettingsKeys.CATEGORY_BACKGROUND_COLOR
};
export function mergeAppSettingsColorsToStyleParamsColors(appSettings, mergeOpacityToColor) {
  function mapOpacity(_ref) {
    let {
      appSettingsColor
    } = _ref;
    if (mergeOpacityToColor) {
      if (appSettingsColor.value.startsWith('rgba')) {
        const opacity = appSettingsColor.value.split(',').pop();
        if (opacity) {
          return parseFloat(opacity.replace(')', ''));
        }
      } else if (appSettingsColor.value.startsWith('rgb') || appSettingsColor.value.startsWith('#')) {
        return 1;
      }
    }
    return appSettingsColor.opacity;
  }
  function mapColor(_ref2) {
    let {
      appSettingsColor
    } = _ref2;
    if (appSettingsColor) {
      return {
        value: appSettingsColor.value,
        opacity: mapOpacity({
          appSettingsColor
        })
      };
    }
    return null;
  }
  const newColors = {};
  Object.keys(stylesParamColorKeyToAppSettingsMapper).forEach(styleParamsColorKey => {
    newColors[styleParamsColorKey] = mapColor({
      appSettingsColor: appSettings[stylesParamColorKeyToAppSettingsMapper[styleParamsColorKey]]
    });
  });
  return cleanNulls(newColors);
}
//# sourceMappingURL=mergeColors.js.map